import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import CtaSection from '@/pages/home/components/CtaSection';
import SeoIntro from '@/pages/home/components/SeoIntro';
import ArticleCards from '@/pages/home/components/ArticleCards';
import Footer from '@/pages/home/components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.pics';
const faviconUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'Kakobuy Finds',
      url: siteUrl,
      description:
        'The ultimate Kakobuy Spreadsheet hub for smart shopping. Discover curated product finds, compare shopping spreadsheets, and access updated shopping guides.',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: 'Kakobuy Finds',
      url: siteUrl,
      logo: faviconUrl,
      sameAs: ['https://kaspreadsheet.com'],
    },
  ],
};

export default function Home() {
  return (
    <main id="top">
      <JsonLd data={homeSchema} />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <CtaSection />
      <SeoIntro />
      <ArticleCards />
      <Footer />
    </main>
  );
}